import { useParams } from "react-router";
import Borrower from "../../components/loan/borrower/Borrower";
import { getApi } from "../../services/api/globalApi";
import {  useEffect, useState } from "react";
import Guarantor from "../../components/loan/guarantor/Guarantor";
import Steps from "../../components/loan/steps/Steps";
import { Link } from "react-router-dom";
import LoanDetails from "../../components/loan/loan-details/LoanDetails";

const Loan = () => {
  const params = useParams();
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState(1);

  const getLoan = async () => {
    const path = `/admin/loans/${params?.id}`;
    try {
      const response = await getApi({ path });
      setData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLoan();
  }, []);

  return (
    <>
      <ol class="flex items-center w-11/12 mx-auto p-3 space-x-2 text-sm font-medium text-center text-gray-500 bg-white border border-gray-200 rounded-lg shadow-sm dark:text-gray-400 sm:text-base dark:bg-gray-800 dark:border-gray-700 sm:p-4 sm:space-x-4 rtl:space-x-reverse">
        <li
          onClick={() => setActiveTab(1)}
          class={`flex items-center cursor-pointer ${
            activeTab === 1 && "text-blue-600 dark:text-blue-500"
          }`}
        >
          <span class="flex items-center justify-center w-5 h-5 me-2 text-xs border border-blue-600 rounded-full shrink-0 dark:border-blue-500">
            1
          </span>
          اطلاعات <span class="hidden sm:inline-flex sm:ms-2">وام گیرنده</span>
          <svg
            class="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 12 10"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m7 9 4-4-4-4M1 9l4-4-4-4"
            />
          </svg>
        </li>
        <li
          onClick={() => setActiveTab(2)}
          class={`flex items-center cursor-pointer ${
            activeTab === 2 && "text-blue-600 dark:text-blue-500"
          }`}
        >
          <span class="flex items-center justify-center w-5 h-5 me-2 text-xs border border-gray-500 rounded-full shrink-0 dark:border-gray-400">
            2
          </span>
          اطلاعات <span class="hidden sm:inline-flex sm:ms-2">ضامنین</span>
          <svg
            class="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 12 10"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m7 9 4-4-4-4M1 9l4-4-4-4"
            />
          </svg>
        </li>
        <li
          onClick={() => setActiveTab(3)}
          class={`flex items-center cursor-pointer ${
            activeTab === 3 && "text-blue-600 dark:text-blue-500"
          }`}
        >
          <span class="flex items-center justify-center w-5 h-5 me-2 text-xs border border-gray-500 rounded-full shrink-0 dark:border-gray-400">
            3
          </span>
          مراحل <span class="hidden sm:inline-flex sm:ms-2"></span>
          <svg
            class="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 12 10"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m7 9 4-4-4-4M1 9l4-4-4-4"
            />
          </svg>
        </li>

        <Link to={`/loan-all-info/${data?._id}`}>
          <li
            onClick={() => setActiveTab(4)}
            class={`flex items-center cursor-pointer ${
              activeTab === 4 && "text-blue-600 dark:text-blue-500"
            }`}
          >
            <span class="flex items-center justify-center w-5 h-5 me-2 text-xs border border-gray-500 rounded-full shrink-0 dark:border-gray-400">
              4
            </span>
            نمایش کل
          </li>
        </Link>
        <li
          onClick={() => setActiveTab(5)}
          class={`flex items-center cursor-pointer ${
            activeTab === 5 && "text-blue-600 dark:text-blue-500"
          }`}
        >
          <span class="flex items-center justify-center w-5 h-5 me-2 text-xs border border-gray-500 rounded-full shrink-0 dark:border-gray-400">
            5
          </span>
          جزئیات <span class="hidden sm:inline-flex sm:ms-2"></span>
          <svg
            class="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 12 10"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m7 9 4-4-4-4M1 9l4-4-4-4"
            />
          </svg>
        </li>
      </ol>
      {activeTab === 1 && <Borrower data={data} reGetData={getLoan} />}
      {activeTab === 2 && <Guarantor data={data} reGetData={getLoan} />}
      {activeTab === 3 && <Steps data={data} reGetData={getLoan} />}
      {activeTab === 5 && <LoanDetails data={data} />}
    </>
  );
};

export default Loan;
